import Enum from '@/modules/core/app/helpers/Enum';
import { EstateType } from '@/modules/estate/enums/EstateType';

export class EstateSignUpType extends Enum {
  static CLEAR_VAULT = EstateType.CLEAR_VAULT.key;
  static STANDARD_PLAN = 'standard_plan';
  static BASIC_PLAN = 'basic_plan';
  static DIGITAL_VAULT_PLAN = 'digital_vault_plan';
  static CLEAR_ESTATE = EstateType.CLEAR_ESTATE.key;
  static FINANCIAL_ADVISOR = 'financial_advisor';
  static PARTNER_SELF_SERVE_PLAN = 'partner_self_serve_plan';
  static AFTERCARE= 'aftercare';
}
